import { useEffect, useState } from "react";
import { browserDeviceIdentityStore, ensureDeviceId, type DeviceIdentityStore } from "./deviceIdentity.ts";
import { usePresenceReporter } from "./presence.ts";
import { useActiveWorkspaceId, useDayviseClient, useSession } from "./providers.tsx";

export interface PresenceReporterProps {
  readonly platform: "web" | "desktop";
  readonly callCapable?: boolean;
  readonly store?: DeviceIdentityStore;
}

export function PresenceReporter({ platform, callCapable = false, store }: PresenceReporterProps): null {
  const client = useDayviseClient();
  const workspaceId = useActiveWorkspaceId();
  const { session } = useSession();
  const userId = session.account?.userId ?? null;
  const [deviceId, setDeviceId] = useState<string | null>(null);

  useEffect(() => {
    setDeviceId(null);
    if (workspaceId === null || userId === null) return;
    let cancelled = false;
    void ensureDeviceId(client, platform, store ?? browserDeviceIdentityStore(`dayvise.deviceToken.${platform}`))
      .then((resolved) => { if (!cancelled) setDeviceId(resolved); })
      .catch(() => { if (!cancelled) setDeviceId(null); });
    return () => { cancelled = true; };
  }, [client, platform, store, userId, workspaceId]);

  usePresenceReporter({ deviceId, callCapable, client: platform });
  return null;
}
